import React from "react";
import { getTranslation } from "../TranslationWrapper/TranslationWrapper";
import * as actions from "../../store/actions";
import { connect } from "react-redux";
import AsynchronousAutocomplete from "../Autocomplete/AsynchronousAutocomplete";

function DebtorFilter(props) {
  return (
    <AsynchronousAutocomplete
      async={{
        url: "core/subsDebtor/search?fields=id as value, company_name as label&per_page=30",
        searchField: "company_name",
      }}
      onChange={(e, option) => {
        if (option) {
          props.setFilter("subs_debtor_id", {
            field: "subs_debtor_id",
            operator: "=",
            value: option.value,
            label: option.label,
          });
        } else {
          props.setFilter("subs_debtor_id", null);
        }
      }}
      placeholder={getTranslation("Filter on debtor")}
      value={props.subs_debtor_id}
    />
  );
}

const mapStateToProps = (state) => ({ subs_debtor_id: state.filtersV2.subs_debtor_id });

const mapDispatchToProps = (dispatch) => ({
  setFilter: (key, filter) => {
    dispatch({ type: actions.SET_FILTER, payload: { key, filter } });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DebtorFilter);
